import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <section className="py-32 text-center">
        <p className="catalog-label">Checking session…</p>
      </section>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}
